import * as React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import {
  ListSubheader,
  List,
  LinearProgress,
  ButtonBase,
} from '@material-ui/core';
import EpgListItem from './epgListItem';
import { epg as Language } from '../../../../Util/language.json';

const propTypes = {
  auth: PropTypes.object.isRequired,
  epgs: PropTypes.shape({
    type: PropTypes.string,
    epgList: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  epgUpdate: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  channel: PropTypes.shape({
    _id: PropTypes.number,
    ch: PropTypes.string,
    epg: PropTypes.string,
    ext: PropTypes.string,
    ext_thumbnail: PropTypes.string,
    group: PropTypes.string,
    logo: PropTypes.string,
    number: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  // channelList: PropTypes.
};

const defaultProps = {
  epgs: {
    type: '',
    epgList: [],
  },
  channel: null,
  // channelList:
  auth: {},
  signOut: null,
  epgUpdate: null,
};

class EpgList extends React.Component<propTypes> {
  componentDidMount() {
    const { epgUpdate, channel } = this.props;
    epgUpdate(channel.epg, () => { });
  }

  shouldComponentUpdate(nextProps) {
    const { epgs, channel, auth } = this.props;
    const { epgs: epgsNext, channel: channelNext, auth: authNext } = nextProps;
    if (channel.epg !== channelNext.epg) {
      this.props.epgUpdate(channelNext.epg);
      return true;
    } else if (
      epgs !== epgsNext ||
      channel !== channelNext ||
      auth !== authNext
    ) {
      return true;
    }
    return false;
  }

  handlerSignOut() {
    this.props.signOut();
  }

  render() {
    const { epgs, channel } = this.props;
    return (
      <div id="epg-container" style={{ color: 'white' }}>
        <div className="actionbar">
          <Link className="back" to="/player" replace />
          {channel && (
            <div className="body-field">
              <img
                className="body-field--logo"
                alt={channel.group_title}
                src={`../../logos/${channel.group_id}/${channel.logo}`}
              />
              <div className="ic--epg" />
            </div>
          )}
          <ButtonBase
            classes={{ root: 'logout' }}
            onClick={this.handlerSignOut.bind(this)}
          >
            {Language.signout}
          </ButtonBase>
        </div>
        {!epgs.load && <LinearProgress color='secondary' />}
        <div className="container">
          <div className="container--scroll">
            <List classes={{ root: 'epg-list--root' }} subheader={<li />}>
              {epgs.epgList.length > 0 &&
                epgs.epgList.map((epg, i) => (
                  <li className="epg-list--item" key={epg.day}>
                    <ul className="epg-list--ul">
                      <ListSubheader
                        className="sub--header sticky"
                        id={`sub--header-${i}`}
                      >
                        <span className="date">{epg.day}</span>
                      </ListSubheader>
                      {epg.list.map(
                        epgItem =>
                          new Date().getTime() > epgItem.stopTime && (
                            <EpgListItem
                              epg={epgItem}
                              key={epgItem._id}
                              channel={channel}
                            />
                          ),
                      )}
                    </ul>
                  </li>
                ))}
            </List>
          </div>
        </div>
      </div>
    );
  }
}

EpgList.propTypes = propTypes;
EpgList.defaultProps = defaultProps;

// function findChannel({ list }, epgId) {
//     let channel = null;
//     list.some((ch) => {
//         channel = ch.list.find(chObject => (chObject.epg === epgId));
//         return channel;
//     });
//     return channel;
// }

// const mapStateToProps = (state, props) => {
//     const { EPGDVR } = state;
//     const { id } = props.match.params;
//     const epg = EPGDVR[id] || { epgList: [] };

//     return {
//         ...props,
//         id,
//         epgs: epg.epgList,
//         action: EPGDVR.type,
//         channel: findChannel(state.Channels, id),
//     };
// };

export default EpgList;
